/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkImportFacilityServiceAreasResponseErrorsInner
 */
export interface BulkImportFacilityServiceAreasResponseErrorsInner {
    /**
     * 
     */
    row: number;
    /**
     * 
     */
    zip?: string;
    /**
     * 
     */
    error: string;
}

/**
 * Check if a given object implements the BulkImportFacilityServiceAreasResponseErrorsInner interface.
 */
export function instanceOfBulkImportFacilityServiceAreasResponseErrorsInner(value: object): value is BulkImportFacilityServiceAreasResponseErrorsInner {
    if (!('row' in value) || value['row'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function BulkImportFacilityServiceAreasResponseErrorsInnerFromJSON(json: any): BulkImportFacilityServiceAreasResponseErrorsInner {
    return BulkImportFacilityServiceAreasResponseErrorsInnerFromJSONTyped(json, false);
}

export function BulkImportFacilityServiceAreasResponseErrorsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkImportFacilityServiceAreasResponseErrorsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'row': json['row'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'error': json['error'],
    };
}

export function BulkImportFacilityServiceAreasResponseErrorsInnerToJSON(json: any): BulkImportFacilityServiceAreasResponseErrorsInner {
    return BulkImportFacilityServiceAreasResponseErrorsInnerToJSONTyped(json, false);
}

export function BulkImportFacilityServiceAreasResponseErrorsInnerToJSONTyped(value?: BulkImportFacilityServiceAreasResponseErrorsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'row': value['row'],
        'zip': value['zip'],
        'error': value['error'],
    };
}

